export default __webpack_public_path__ + "static/media/goodreads4.c7c5006c.png";